import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SubdomainService } from '../services/subdomain.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const subdomain = inject(SubdomainService);

  if (auth.isLoggedIn()) {
    return true;
  }

  if (subdomain.subdomain()) {
    return router.createUrlTree(['/landing']);
  }

  return router.createUrlTree(['/login']);
};
